// removed by extract-text-webpack-plugin
module.exports = {"delButton":"detaiModal_delButton_3qi3X"};


//////////////////
// WEBPACK FOOTER
// ./src/components/personal/log/index/detaiModal.scss
// module id = 1554
// module chunks = 0